import { useNavigate } from 'react-router-dom';
import { DashboardLayoutContainer } from 'components/Layouts/DashboardLayout';
import { Box } from '@mui/material';
import { Typography, colors } from '@leapeasy/ui-kit';
import { GlobalUXState } from 'components/GlobalUXState';

export const NotFound = () => {
  const navigate = useNavigate();

  return (
    <DashboardLayoutContainer>
      <Box display="flex" flexDirection="column" alignItems="center" gap="16px" paddingTop="40px">
        <Typography variant="h1" style={{ color: colors.purple[900], fontWeight: 600 }}>
          404
        </Typography>
        <GlobalUXState
          variant="notFound"
          actionLabel="Back to dashboard"
          onAction={() => navigate('/dashboard')}
        />
      </Box>
    </DashboardLayoutContainer>
  );
};
